import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>This is no found page</h1>
        </div>
    );
};

export default NotFound;